import { Vault } from '@/features/vaults/types';

export const ethereumTestKeyrock1VaultId = 'ethereum-test-keyrock-1';

export const ethereumTestKeyrock1: Vault = {
  id: ethereumTestKeyrock1VaultId,
  type: 'core-vault',
  name: 'test Keyrock 1',
  description: '',
  category: 'core-vault',
  address: '0x2C9BD30aa18ABBC6BCC0b045d25bb4944630413B',
  curators: [],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0x2C9BD30aa18ABBC6BCC0b045d25bb4944630413B',
    },
  ],
  baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  lpTokenSymbol: 'tKR',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  allocations: {
    showAllocationsTab: true,
  },
  archived: false,
};
